module.exports = __webpack_public_path__ + "img/utilityheavy_driving.67123534.svg";